module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_14.81998dad.jpeg";